import UIFormControl from 'UIComponents/form/UIFormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import { jsx as _jsx } from "react/jsx-runtime";
const TicketPipelineStageInput = ({
  canEditProperty,
  label,
  onChange,
  options,
  value
}) => /*#__PURE__*/_jsx(UIFormControl, {
  "aria-label": label,
  required: true,
  labelTooltip: !canEditProperty ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "svh-workspace-ui-lib.ticket-header.changePipelineModal.readOnlyProperty"
  }) : undefined,
  children: /*#__PURE__*/_jsx(UISelect, {
    onChange: onChange,
    options: options,
    value: value
  })
});
TicketPipelineStageInput.displayName = 'TicketPipelineStageInput';
export default TicketPipelineStageInput;